
export const HTTP_HEADERS = {
  requestId: 'Arrow-RequestId'
};



// WEBPACK FOOTER //
// ./uikit/config/httpHeaders.js